import { Injectable } from '@angular/core';
import { LikertDataService } from './likert-data.service';
import { Likert } from './model/likert.model';
import { HandlerService } from '../comunicator-native/handler/handler';

@Injectable({
  providedIn: 'root'
})
export class LikertDataMobileService implements LikertDataService {

  constructor(private handlerService: HandlerService) {}

  public postLikert(likertForm: Likert): Promise<any> {
    const relCaronte = 'likert';

    return this.handlerService.caronteCommunicator(relCaronte, likertForm).then((data: any) => {
      return Promise.resolve(data);
    });
  }

  
}